import type { PurchaseOrderLineItemRead } from './types'

export function poLineDisplayNumber(lineItem: PurchaseOrderLineItemRead): string | number {
  return lineItem.source_quote_display_number || lineItem.display_number || lineItem.item_number
}

export function isManufacturerSurchargeLine(lineItem: PurchaseOrderLineItemRead): boolean {
  return lineItem.pricing_source === 'manufacturer_tariff'
}
